const toggleMapModal = (element, toggle) => {
  element.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

// Close Modal
attachEvent('.map-modal__close, .map-modal__overlay', 'click', (ev) => {
  const parentElem = ev.target.closest('.map-modal');
  toggleMapModal(parentElem, false);
  ev.preventDefault();
});

// Open Modal
attachEvent('.map-module__pin-inner', 'click', (ev) => {
  const parentElem = ev.target.closest('.map-module__pin');
  const modal = parentElem.querySelector('.map-modal');
  toggleMapModal(modal, true);
  ev.preventDefault();
});

// Close modal on ESC key press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.map-modal.is-open-modal').forEach((el) => {
      el.classList.remove('is-open-modal');
    });
  }
});
